import { LegendItemDto } from '../../../api/scheduler/models/legend-item-dto';
import { MasterScheduleLegendsDto } from '../../../api/scheduler/models/master-schedule-legends-dto';
import { NamedColor } from '../../../shared/utils/color-distance';

/** Allocation types whose schedule colour a Base must not share; aircraft types are Base colours. */
const RESERVED_TYPES = new Set(['EVENT', 'VACATION', 'TRAINING', 'LEAVE']);

/**
 * Colours the schedules use for Event, Training, Vacation and Leave, labelled for messages
 * (e.g. "Leave: Sick Leave"). A Base on one of these would read as that allocation on a calendar.
 */
export function reservedColorsFromLegends(
  legends: MasterScheduleLegendsDto | null | undefined
): NamedColor[] {
  if (!legends) return [];
  const named = (items: LegendItemDto[] | undefined, group?: string): NamedColor[] =>
    (items ?? [])
      .filter((item) => !!item.colorCode)
      .map((item) => ({
        colorCode: item.colorCode.toUpperCase(),
        label: group ? `${group}: ${item.label}` : item.label,
      }));
  return [
    ...named((legends.types ?? []).filter((item) => RESERVED_TYPES.has(item.code))),
    ...named(legends.eventTypes, 'Event'),
    ...named(legends.trainingTypes, 'Training'),
    ...named(legends.leaveTypes, 'Leave'),
  ];
}
